<template>
  <RenderLandingPage v-if="page.templateName === 'landing'" />
  <RenderThankYouPage v-else-if="page.templateName === 'thankyou'" />
  <RenderInternalPage
    v-else-if="page.templateName"
    :page="page"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useMeta } from 'quasar';
import { useFavicon } from '@vueuse/core';

import { initCookies } from 'boot/axios';
import { useBookPageStore } from 'stores/bookPage';
import RenderLandingPage from 'pages/books/render/RenderLandingPage.vue';
import RenderInternalPage from 'pages/books/render/RenderInternalPage.vue';
import RenderThankYouPage from 'pages/books/render/RenderThankYouPage.vue';
import { ROUTES } from 'src/enums';

defineOptions({
  // eslint-disable-next-line consistent-return
  async preFetch({
    store, currentRoute, ssrContext, redirect,
  }) {
    const bookPageStore = useBookPageStore(store);
    const host = ssrContext
      ? ssrContext.req.hostname
      : window.location.hostname;
    try {
      // eslint-disable-next-line prefer-const
      let { preview, accessToken } = currentRoute.query;
      const query = preview ? '?preview=1' : '';

      const cookies = initCookies(ssrContext);

      if (!accessToken) {
        accessToken = cookies.get('accessToken');
      } else {
        cookies.set('accessToken', accessToken);
      }

      if (!bookPageStore.page?.guid) {
        const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

        const { bookPageSlug, bookSlug } = currentRoute.params;

        await bookPageStore.getPageBySlug({
          slug: `book/${bookSlug}/page/${bookPageSlug}}${query}`,
          host,
          headers,
        });
      }
    } catch (error) {
      const { status } = error.response;
      if (status === 400) {
        redirect({ name: ROUTES.BOOKS.NOT_FOUND });
      }
    }
  },
});

const bookPageStore = useBookPageStore();
const { page, pageData, book } = storeToRefs(bookPageStore);

console.log(page.value?.book.faviconUrl);
const metaData = {
  title: pageData.value.metaTitle || book.value.title,
  meta: {
    description: {
      name: 'description',
      content: pageData.value.metaDescription,
    },
    keywords: {
      name: 'keywords',
      content: pageData.value.metaKeywords,
    },
  },
};

useMeta(metaData);

const favicon = useFavicon();
if (page.value?.book.faviconUrl) {
  favicon.value = page.value?.book.faviconUrl;
}
</script>

<style>
@import 'https://fonts.googleapis.com/css2?family=Mitr:wght@200;300;400;500;600;700&display=swap';
@import "../../../css/regular.css";
</style>

<style lang="scss">
@import "../../../css/book-landing.scss";

.book-landing {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  transition: width .4s;
  color: #000;

  .book-landing-top {
    height: 45px;
    position: sticky;
    top: 0;
    z-index: 4;
  }
}
</style>
